import { MilestoneStatusExt } from './../types';
import { CommodityMilestone, Scalars, Weld } from '@bechtel/types';

export interface UserMetadataProps {
  startDate?: Scalars['Date'];
  endDate?: Scalars['Date'];
  name: Scalars['String'];
  imageUrl: Scalars['String'];
}

export interface CountMetadataProps {
  label: string;
  count: number | string;
}

export interface MilestoneMetadataProps {
  status: MilestoneStatusExt;
  milestone: CommodityMilestone;
}

export interface AssociatedWeldsMetaData {
  weldStatuses: Weld[];
}

export interface WeldoutListProps {
  weldStatuses: Weld[] | null | undefined;
  justifyContent?: string;
  showTooltip?: boolean;
}
